import React from 'react';
import cn from 'classnames';
import { components } from 'react-select';
import { string } from 'prop-types';
import styles from './index.module.scss';

// We are overriding default component, just to pass custom styles to it
export const MenuComponent = (props) => {
    const Menu = components.Menu;
    return <Menu {...props} className={cn(styles.menu, props.className)}/>;
};

MenuComponent.propTypes = {
    className: string
};
